var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',_vm._b({staticClass:"ix-section",attrs:{"loading":_vm.loading,"flat":"","tile":"","color":"white"}},'v-card',_vm.$props,false),[_c('template',{slot:"progress"},[_c('v-progress-linear',{attrs:{"color":"primary","height":"5","indeterminate":""}})],1),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }